module.exports = __webpack_public_path__ + "static/media/21_3.ab91b2e4.png";